import 'css-chunksrc/client/scenes/projectExpenseCreation/form/elementAttachments/styles.scss';export default {
  "elementAttachments": "_elementAttachments_8crzf_1",
  "attachmentsContent": "_attachmentsContent_8crzf_5",
  "label": "_label_8crzf_9",
  "loaderContainer": "_loaderContainer_8crzf_16",
  "attachmentsUploader": "_attachmentsUploader_8crzf_20",
  "dropzone": "_dropzone_8crzf_31",
  "dropPreview": "_dropPreview_8crzf_39",
  "dropPreviewMessage": "_dropPreviewMessage_8crzf_51",
  "attachmentsUploaderContent": "_attachmentsUploaderContent_8crzf_56",
  "text": "_text_8crzf_65",
  "button": "_button_8crzf_70",
  "list": "_list_8crzf_78"
};